import { render, staticRenderFns } from "./CompanyOmsAdd.vue?vue&type=template&id=5f5c9596&scoped=true&"
import script from "./CompanyOmsAdd.vue?vue&type=script&lang=js&"
export * from "./CompanyOmsAdd.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOmsAdd.vue?vue&type=style&index=0&id=5f5c9596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c9596",
  null
  
)

export default component.exports